import React from 'react'
import { SocialBar } from '../extra/SocialBar'
import { ArticleInfo } from './ArticleInfo'

interface authorCardType {
  authorName: string
  publishDate: string
  updatedDate: string
  dark?: boolean
}

export const AuthorCard = (props: authorCardType) => (
  <div className='flex flex-col p-5 md:p-10 rounded-xl border border-[#9ABDEC] bg-white shadow-[0_0.2px_20px_0px_#BBD2D7]'>
    <ArticleInfo
      name={props.authorName}
      publishDate={props.publishDate}
      updatedDate={props.updatedDate}
    />

    <div className='flex flex-col items-center'>
      <hr className='text-[#9FCDD7] w-full my-6 h-px' />

      <SocialBar dark={props.dark} />
    </div>
  </div>
)
